interface RadioInputProps {
  name: string;
  value: string;
  checked: boolean;
  label: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  selectedClassName?: string;
}

export const RadioInput = ({
  name,
  value,
  checked,
  label,
  onChange,
  disabled = false,
  className = 'nova-delivery-card',
  selectedClassName = 'nova-delivery-card-selected',
}: RadioInputProps) => {
  return (
    <label className={`${className} ${checked ? selectedClassName : ''}`.trim()}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="form-check-input"
        disabled={disabled}
      />
      <span className="nova-delivery-label">{label}</span>
    </label>
  );
};

export default RadioInput;
